import { useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import classNames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';

import { CheckoutServerVarsContext } from '../../components/shared/CheckoutServerVarsContext';

// components
import CheckoutCreditCardForm from './CheckoutCreditCardForm';

import styles from './styles/CheckoutAddCreditCardStyles.scss';

const CheckoutAddCreditCard = ({
    viewer,
    buyer,
    isSelected = false,
    onSelect,
    onCancel,
    checkoutPaymentErrors,
    onValidationUpdate,
    onValidationError,
}) => {
    const { isMobile } = useContext(CheckoutServerVarsContext);

    return (
        <div
            className={classNames(styles.wrapper, {
                [styles.isMobile]: isMobile,
            })}
        >
            <Link
                dataTn="add-credit-card"
                className={styles.link}
                onClick={() => {
                    if (isSelected) {
                        onCancel();
                    } else {
                        onSelect(null, null, isSelected);
                    }
                }}
            >
                {isSelected ? (
                    <FormattedMessage
                        id="checkout.CheckoutAddCreditCard.cancel"
                        defaultMessage="Cancel"
                    />
                ) : (
                    <FormattedMessage
                        id="checkout.CheckoutAddCreditCard.addTitle"
                        defaultMessage="Add new credit/ debit card"
                    />
                )}
            </Link>
            {isSelected && (
                <div className={styles.cardFormWrapper}>
                    <CheckoutCreditCardForm
                        {...{
                            viewer,
                            buyer,
                            checkoutPaymentErrors,
                            onValidationUpdate,
                            onValidationError,
                        }}
                    />
                </div>
            )}
        </div>
    );
};

CheckoutAddCreditCard.propTypes = {
    viewer: PropTypes.object.isRequired,
    buyer: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    checkoutPaymentErrors: PropTypes.object.isRequired,
    onValidationUpdate: PropTypes.func.isRequired,
    onValidationError: PropTypes.func.isRequired,
};

export default createFragmentContainer(CheckoutAddCreditCard, {
    viewer: graphql`
        fragment CheckoutAddCreditCard_viewer on Viewer {
            ...CheckoutCreditCardForm_viewer
        }
    `,
    buyer: graphql`
        fragment CheckoutAddCreditCard_buyer on User {
            ...CheckoutCreditCardForm_buyer
        }
    `,
});
